import React from 'react';

const ArrowSwapHorizontal: React.FC<React.SVGProps<SVGSVGElement>> = ({
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M22 18H7V16H22V18Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 11.5858L23.4142 17L18 22.4142L16.5858 21L20.5858 17L16.5858 13L18 11.5858Z"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M2 6H18V8H2V6Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.41424 3.00003L3.41424 7.00003L7.41424 11L6.00003 12.4142L0.585815 7.00003L6.00003 1.58582L7.41424 3.00003Z"
      />
    </svg>
  );
};

export default ArrowSwapHorizontal;
